/* eslint-disable max-len */
const React = require('react');
const ViewMosaic24 = require('@andes/icons/ViewMosaic24');
const PaymentLink = require('@andes/icons/PaymentLink24');
const Recurring = require('@andes/icons/Recurringpayments24');
const QrCode = require('@andes/icons/QRCode24');
const Point = require('@andes/icons/PointMLA24');
const { TagChoice } = require('@andes/tag');
const { Title } = require('@andes-landings/title');

const CardFormat = require('./card');
const { getSite } = require('../../../../../utils/location');

const { useState } = React;

const Documentations = ({ i18n, lang, siteId, brand }) => {
  const colorImg = '#009EE3';
  const location = getSite(siteId);

  const isMLB = siteId === 'MLB';
  const isMLM = siteId === 'MLM';
  const linkPayment = isMLB ? `https://www.mercadopago${location}/ferramentas-para-vender/link-de-pagamento` : `https://www.mercadopago${location}/herramientas-para-vender/link-de-pago`;
  const linkSubscriptionPlan = `/developers/${lang}/docs/subscription-plans/landing`;
  const labelChoAPI = isMLB ? i18n.gettext('Checkout Transparente') : i18n.gettext('Checkout API');
  const descriptionPoint = isMLM ? i18n.gettext('Lector de tarjetas.') : i18n.gettext('Lector de tarjetas o QR.');

  const offlineObject = [
    { icon: <QrCode color={colorImg} />, title: i18n.gettext('Código QR'), description: i18n.gettext('Opción de pago escaneando un código.'), isNew: false, siteID: ['MLA', 'MLB', 'MLU', 'MLC'], link: `/developers/${lang}/docs/qr-code/landing`, label: i18n.gettext('Código QR'), event: 'QR_CODE' },
    { icon: <Point color={colorImg} />, title: i18n.gettext('Mercado Pago Point'), description: descriptionPoint, isNew: false, siteID: ['MLA', 'MLB', 'MLM'], link: `/developers/${lang}/docs/mp-point/landing`, label: i18n.gettext('Mercado Pago Point'), event: 'MP_POINT' },
  ];
  const offlinePayments = offlineObject.filter((m) => m.siteID.includes('allSites') || m.siteID.includes(siteId));

  const onlineObject = [
    { icon: <ViewMosaic24 color={colorImg} />, title: i18n.gettext('Checkout Pro'), description: i18n.gettext('Prediseño listo para configurar.'), isNew: false, siteID: ['allSites'], link: `/developers/${lang}/docs/checkout-pro/overview`, label: 'Checkout Pro', event: 'CHECKOUT_PRO' },
    { icon: <ViewMosaic24 color={colorImg} />, title: isMLB ? i18n.gettext('Checkout Transparente') : i18n.gettext('Checkout API'), description: i18n.gettext('Opción 100% personalizable en tu sitio.'), isNew: false, siteID: ['allSites'], link: `/developers/${lang}/docs/checkout-api/landing`, label: labelChoAPI, event: 'CHECKOUT_API' },
    { icon: <ViewMosaic24 color={colorImg} />, title: i18n.gettext('Checkout Bricks'), description: i18n.gettext('Módulos flexibles para pagar en tu sitio.'), isNew: false, siteID: ['allSites'], link: `/developers/${lang}/docs/checkout-bricks/landing`, label: 'Checkout Bricks', event: 'CHECKOUT_BRICKS' },
    { icon: <PaymentLink color={colorImg} />, title: i18n.gettext('Link de pago'), description: i18n.gettext('Enlace para compartir o crear un botón.'), isNew: false, siteID: ['allSites'], link: linkPayment, label: 'Link de pago', event: 'PAYMENT_LINK' },
    { icon: <Recurring color={colorImg} />, title: i18n.gettext('Suscripciones'), description: i18n.gettext('Automatización de pagos recurrentes.'), isNew: false, siteID: ['allSites'], link: `/developers/${lang}/docs/subscriptions/landing`, label: i18n.gettext('Suscripciones'), event: 'SUBSCRIPTIONS' },
    { icon: <Recurring color={colorImg} />, title: i18n.gettext('Planes de suscripción'), description: i18n.gettext('Gestión simple de pagos recurrentes.'), isNew: false, siteID: ['allSites'], link: linkSubscriptionPlan, label: i18n.gettext('Planes de suscripción'), event: 'SUBSCRIPTIONS_PLANS' },
  ];


  const onlinePayments = onlineObject.filter((m) => m.siteID.includes('allSites') || m.siteID.includes(siteId));


  const [onChecked, setOnChecked] = useState(false);
  const [offChecked, setOffChecked] = useState(false);
  const [allChecked, setAllChecked] = useState(true);
  const conditionSite = (siteId === 'MCO') || (siteId === 'MPE');

  return (
    <div className={`documentation-container documentation-${brand}`} id="all-docs">
      <div className="documentation-sub-container">
        <Title
          className="documentation-title"
          title={i18n.gettext('Todas nuestras soluciones')}
          description={i18n.gettext('Encuentra las opciones que ofrecemos por su nombre técnico y modalidad de uso.')}
          isHero
          align="center"
            />
        <div className="documentation-select">
          <div className="documentation-choice-container">
            <TagChoice
              label={i18n.gettext('Todas')}
              size="small"
              selected={allChecked}
              onClick={() => { setAllChecked(true); setOnChecked(false); setOffChecked(false); }}
            />
            <TagChoice
              label={i18n.gettext('Cobro online')}
              size="small"
              selected={onChecked}
              onClick={() => { setOnChecked(true); setAllChecked(false); setOffChecked(false); }}
            />
            {!conditionSite && <TagChoice
              label={i18n.gettext('Cobro presencial')}
              size="small"
              selected={offChecked}
              onClick={() => {
                setOffChecked(true);
                setAllChecked(false);
                setOnChecked(false);
              }}
            />}
          </div>
          <div className="documentation-cards-container" data-brand={brand}>
            {((onChecked) || (allChecked)) && onlinePayments.map(element => (
              <CardFormat icon={element.icon} title={element.title} description={element.description} link={element.link} event={element.event} lang={lang} labelElement={element.label} brand={brand} />
            ))}
            {((offChecked) || (allChecked)) && offlinePayments.map(element => (
              <CardFormat icon={element.icon} title={element.title} description={element.description} link={element.link} event={element.event} lang={lang} labelElement={element.label} brand={brand} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

module.exports = Documentations;
